module.exports = {
    GITHUB_CLIENT_ID:"Iv1.75bbd3275fb2fe2a",
    GITHUB_REDIRECT_URI:"https://www.leagueofrobotrunners.org/github-login",
}
